// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.warning-bg {
  border-radius: 70px;
  background: rgba(217, 45, 32, 0.1);
}

.modal-meeting-details .modal-container {
  width: 580px !important;
  height: 504px !important;
}
.modal-meeting-details .modal-header {
  padding: 0 !important;
  border-bottom: 0 !important;
}
.modal-meeting-details .modal-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.modal-meeting-details .modal-footer {
  padding-top: 0 !important;
  border-top: 0 !important;
}

.modal-datetime .modal-header {
  padding: 0 !important;
  border-bottom: 0 !important;
}
.modal-datetime .modal-container {
  width: 580px !important;
  height: 388px !important;
}
.modal-datetime .modal-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.modal-datetime .modal-footer {
  padding-top: 0 !important;
  border-top: 0 !important;
}

.modal-venue .modal-header {
  padding: 0 !important;
  border-bottom: 0 !important;
  padding: 32px !important;
  padding-bottom: 0 !important;
}
.modal-venue .modal-container {
  width: 580px !important;
  height: 736px !important;
}
.modal-venue .modal-content {
  display: flex;
  flex-direction: column;
  padding-top: 24px !important;
  padding-bottom: 24px !important;
}
.modal-venue .modal-footer {
  padding-top: 0 !important;
  border-top: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/routes/event-dashboard/components/eventDetails/style.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,kCAAA;AACJ;;AAGI;EACI,uBAAA;EACA,wBAAA;AAAR;AAEI;EACI,qBAAA;EACA,2BAAA;AAAR;AAEI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AAAR;AAEI;EACI,yBAAA;EACA,wBAAA;AAAR;;AAKI;EACI,qBAAA;EACA,2BAAA;AAFR;AAKI;EACI,uBAAA;EACA,wBAAA;AAHR;AAKI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AAHR;AAKI;EACI,yBAAA;EACA,wBAAA;AAHR;;AAQI;EACI,qBAAA;EACA,2BAAA;EACA,wBAAA;EACA,4BAAA;AALR;AAQI;EACI,uBAAA;EACA,wBAAA;AANR;AAQI;EACI,aAAA;EACA,sBAAA;EACA,4BAAA;EACA,+BAAA;AANR;AAQI;EACI,yBAAA;EACA,wBAAA;AANR","sourcesContent":[".warning-bg{\n    border-radius: 70px;\n    background: rgba(217, 45, 32, 0.10);\n}\n\n.modal-meeting-details{\n    .modal-container{\n        width: 580px !important;\n        height: 504px !important;\n    }\n    .modal-header{\n        padding: 0 !important;\n        border-bottom: 0 !important;\n    } \n    .modal-content{\n        display: flex;\n        flex-direction: column;\n        gap: 24px;\n    } \n    .modal-footer{\n        padding-top: 0 !important;\n        border-top: 0 !important;\n    }\n}\n\n.modal-datetime{\n    .modal-header{\n        padding: 0 !important;\n        border-bottom: 0 !important;\n    } \n\n    .modal-container{\n        width: 580px !important;\n        height: 388px !important;\n    }\n    .modal-content{\n        display: flex;\n        flex-direction: column;\n        gap: 24px;\n    } \n    .modal-footer{\n        padding-top: 0 !important;\n        border-top: 0 !important;\n    }\n}\n\n.modal-venue{\n    .modal-header{\n        padding: 0 !important;\n        border-bottom: 0 !important;\n        padding: 32px !important;\n        padding-bottom: 0 !important;\n    } \n\n    .modal-container{\n        width: 580px !important;\n        height: 736px !important;\n    }\n    .modal-content{\n        display: flex;\n        flex-direction: column;\n        padding-top: 24px !important;\n        padding-bottom: 24px !important;\n    } \n    .modal-footer{\n        padding-top: 0 !important;\n        border-top: 0 !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
